export default {
  computed: {
    rotateTurn () {
      return this.value / 100
    },
    colorClass () {
      return this.value > 50 ? 'over' : 'short'
    },
    graphHight () { // .graph の hight
      // pcは60、spは80
      return this.$route.name.endsWith('Sp') ? 80 : 60
    },
    averageHight () {
      return this.graphHight / 2
    },
    thisHight () {
      if (!this.averageValue) return 0
      const hight = (this.averageHight / this.averageValue) * this.value
      return hight > this.graphHight ? this.graphHight : hight
    }
  }
}
